import { Skeleton } from "@dash/skeleton";

import { Row, SyncResult } from "@megaron/import-export";

import { SyncErrorsTable } from "./SyncErrorsTable";
import { SyncOperationsTable } from "./SyncOperationsTable";

type Props<T extends Row> = {
  isLoading: boolean;
  result: SyncResult<T> | undefined;
  labels: { [key in keyof T]?: string };
};

export const SyncResultView = <T extends Row>(props: Props<T>) => {
  return (
    <div css={{ overflow: "auto", display: "flex", flexDirection: "column", gap: "2rem" }}>
      <SyncErrorsTable isLoading={props.isLoading} errors={props.result?.errors} labels={props.labels} />
      <SyncOperationsTable isLoading={props.isLoading} operations={props.result?.operations} labels={props.labels} />
    </div>
  );
};
